<template>
	<div>
		<right-panel :datas="connects" :items="connects" @onClose="onCloseForm" @onSubmit="onSubmitForm" ref="right-panel">
			<div slot="header">
				<translate>Change Nickname</translate>
			</div>
		</right-panel>
	</div>
</template>

<script>
import STORE_CONST from '../../../store/consts'
import RightPanel from '../../common/right-panel'
export default {
	name: 'EditName',
	props: {
		items: {
			required: true,
		},
	},
	data() {
		return {
			connects: null,
		}
	},
	methods: {
		onSubmitForm() {
			let params = {
				name: this.$refs['right-panel'].profileModel.name,
			}
			this.$store
				.dispatch(STORE_CONST.ACCOUNT.UPDATE, { data: params })
				.then(() => {
					this.onCloseForm()
					this.$notify({
						message: this.$gettext('Change successful'),
						type: 'success',
					})
					this.$store.dispatch(STORE_CONST.ACCOUNT.CURRENT)
				})
				.catch((err) => {
					console.log('err', err)
					this.$refs['right-panel'].onSubmitErr()
				})
		},
		onCloseForm() {
			this.connects = null
			this.$emit('onClosePanel')
		},
	},
	watch: {
		items: {
			handler: function (newVal) {
				if (this.connects) {
					this.connects = null
					setTimeout(() => {
						this.connects = this.items
					}, 300)
				} else {
					this.connects = this.items
				}
			},
			deep: true,
		},
	},
	components: {
		RightPanel,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss"></style>



// WEBPACK FOOTER //
// account-edit-name.vue?3cba1bd1